import React from 'react';
import classNames from 'classnames';

import css from './Topbar.module.css';

/**
 * Menu icon — Figma three-line mark (uneven widths).
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className
 * @param {string?} props.rootClassName
 * @param {string?} props.ariaLabel
 * @returns {JSX.Element}
 */
const MenuIcon = props => {
  const { className, rootClassName, ariaLabel } = props;
  const classes = classNames(rootClassName || css.rootMenuIcon, className);

  return (
    <svg
      className={classes}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={ariaLabel}
    >
      <path d="M4 5H16" stroke="currentColor" strokeWidth="1.25" strokeLinejoin="round" />
      <path d="M4 12H20" stroke="currentColor" strokeWidth="1.25" strokeLinejoin="round" />
      <path d="M4 19H12" stroke="currentColor" strokeWidth="1.25" strokeLinejoin="round" />
    </svg>
  );
};

export default MenuIcon;
